import { Score } from './score';
export class Result {
    _score;
    success;
    completion;
    duration;
    response;
    extensions;
    constructor(cfg = {}) {
        const { score, success, duration, completion, response, extensions } = cfg;
        this.score = this.fix_score(score);
        this.success = success;
        this.duration = duration;
        this.completion = completion;
        this.response = response;
        this.extensions = extensions;
    }
    fix_score(value) {
        return value && (value instanceof Score ? value : new Score(value));
    }
    get score() {
        return this._score;
    }
    set score(value) {
        this._score = value;
    }
    asVersion(version = '1.0.3') {
        const result = {};
        const { score, success, duration, completion, response, extensions } = this;
        result.score = score?.asVersion();
        result.success = success;
        result.duration = duration;
        result.completion = completion;
        result.response = response;
        result.extensions = extensions;
        return result;
    }
    static fromJSON(resultJSON) {
        const _result = JSON.parse(resultJSON);
        return new Result(_result);
    }
}
